/* eslint-disable react/function-component-definition */
import React, { useContext, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { toast, ToastContainer } from "react-toastify";
import { useDispatch } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/fontawesome-free-solid";
import { Entry } from "../../redux/entrySlice";
import SelectBox from "../../components/SelectBox/SelectBox";
import PhoneNumberInput from "../../components/PhoneNumberBox/PhoneNumberBox";
import styles from "./createVendorPopup.module.scss";
import { TableContext } from "../../contexts/tableContext";
import MultipleFileUpload from "../../components/MultipleFileUpload/MultipleFileUpload";
import "react-toastify/dist/ReactToastify.css";
import TextInput from "../../components/TextField/TextField";
import EmailInput from "../../components/EmailBox/EmailBox";
import { REACT_APP_API_ROLES_DROPDOWN } from "../../redux/apiConstants";
import { useNavigate } from "react-router-dom";
import { Label } from "reactstrap";
import PasswordField from "../../components/PasswordField/PasswordField";
import { getCookies } from "../../hooks/useCookies";

const COUNTRY_CODES = [
  { label: "+1 (US/Canada)", value: "+1" },
  { label: "+7 (Russia)", value: "+7" },
  { label: "+20 (Egypt)", value: "+20" },
  { label: "+27 (South Africa)", value: "+27" },
  { label: "+30 (Greece)", value: "+30" },
  { label: "+31 (Netherlands)", value: "+31" },
  { label: "+32 (Belgium)", value: "+32" },
  { label: "+33 (France)", value: "+33" },
  { label: "+34 (Spain)", value: "+34" },
  { label: "+36 (Hungary)", value: "+36" },
  { label: "+39 (Italy)", value: "+39" },
  { label: "+40 (Romania)", value: "+40" },
  { label: "+41 (Switzerland)", value: "+41" },
  { label: "+43 (Austria)", value: "+43" },
  { label: "+44 (United Kingdom)", value: "+44" },
  { label: "+45 (Denmark)", value: "+45" },
  { label: "+46 (Sweden)", value: "+46" },
  { label: "+47 (Norway)", value: "+47" },
  { label: "+48 (Poland)", value: "+48" },
  { label: "+49 (Germany)", value: "+49" },
  { label: "+51 (Peru)", value: "+51" },
  { label: "+52 (Mexico)", value: "+52" },
  { label: "+53 (Cuba)", value: "+53" },
  { label: "+54 (Argentina)", value: "+54" },
  { label: "+55 (Brazil)", value: "+55" },
  { label: "+56 (Chile)", value: "+56" },
  { label: "+57 (Colombia)", value: "+57" },
  { label: "+58 (Venezuela)", value: "+58" },
  { label: "+60 (Malaysia)", value: "+60" },
  { label: "+61 (Australia)", value: "+61" },
  { label: "+62 (Indonesia)", value: "+62" },
  { label: "+63 (Philippines)", value: "+63" },
  { label: "+64 (New Zealand)", value: "+64" },
  { label: "+65 (Singapore)", value: "+65" },
  { label: "+66 (Thailand)", value: "+66" },
  { label: "+81 (Japan)", value: "+81" },
  { label: "+82 (South Korea)", value: "+82" },
  { label: "+84 (Vietnam)", value: "+84" },
  { label: "+86 (China)", value: "+86" },
  { label: "+90 (Turkey)", value: "+90" },
  { label: "+91 (India)", value: "+91" },
  { label: "+92 (Pakistan)", value: "+92" },
  { label: "+93 (Afghanistan)", value: "+93" },
  { label: "+94 (Sri Lanka)", value: "+94" },
  { label: "+95 (Myanmar)", value: "+95" },
  { label: "+98 (Iran)", value: "+98" },
  { label: "+212 (Morocco)", value: "+212" },
  { label: "+213 (Algeria)", value: "+213" },
  { label: "+216 (Tunisia)", value: "+216" },
  { label: "+218 (Libya)", value: "+218" },
  { label: "+220 (Gambia)", value: "+220" },
  { label: "+221 (Senegal)", value: "+221" },
  { label: "+234 (Nigeria)", value: "+234" },
  { label: "+254 (Kenya)", value: "+254" },
  { label: "+256 (Uganda)", value: "+256" },
  { label: "+260 (Zambia)", value: "+260" },
  { label: "+263 (Zimbabwe)", value: "+263" },
  { label: "+351 (Portugal)", value: "+351" },
  { label: "+352 (Luxembourg)", value: "+352" },
  { label: "+353 (Ireland)", value: "+353" },
  { label: "+354 (Iceland)", value: "+354" },
  { label: "+358 (Finland)", value: "+358" },
  { label: "+380 (Ukraine)", value: "+380" },
  { label: "+381 (Serbia)", value: "+381" },
  { label: "+385 (Croatia)", value: "+385" },
  { label: "+386 (Slovenia)", value: "+386" },
  { label: "+420 (Czech Republic)", value: "+420" },
  { label: "+421 (Slovakia)", value: "+421" },
  { label: "+966 (Saudi Arabia)", value: "+966" },
  { label: "+971 (UAE)", value: "+971" },
  { label: "+972 (Israel)", value: "+972" },
  { label: "+973 (Bahrain)", value: "+973" },
  { label: "+974 (Qatar)", value: "+974" },
  { label: "+975 (Bhutan)", value: "+975" },
  { label: "+976 (Mongolia)", value: "+976" },
  { label: "+977 (Nepal)", value: "+977" },
  { label: "+994 (Azerbaijan)", value: "+994" },
  { label: "+995 (Georgia)", value: "+995" },
  { label: "+996 (Kyrgyzstan)", value: "+996" },
  { label: "+998 (Uzbekistan)", value: "+998" },
];

const CreateVendorPopup = React.memo(({ handleClose, setIsUpdated }) => {
  const [submiting, setSubmitting] = useState(false);
  const { setDashboardHeader } = useContext(TableContext);
  const { errormsgStyle } = useContext(TableContext);
  const [roles, setRoles] = useState([]);
  const navigate = useNavigate();
  const [error, setError] = useState(null);
  const [perror, setPerror] = useState(null);
  const [twoFactorEnabled, setTwoFactorEnabled] = useState(false);
  const isSuperAdmin = getCookies("ISSUPERADMIN") === "true";

  useEffect(() => {
    window.scrollTo(0, 0);
    // setDashboardHeader("Add Vendor Details");
    const url = REACT_APP_API_ROLES_DROPDOWN;
    fetch(url)
      .then((resp) => resp.json())
      .then((resp) => {
        console.log(resp.data.role);
        setRoles(resp.data.role.selectdata);
      }); // setting response to state roles
  }, []);
  const dispatch = useDispatch();
  const { files } = useContext(TableContext);
  const {
    control,
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();
  function onSubmitdata(data) {
    if (data?.name?.trim().length === 0) {
      toast.error("Name cannot be empty");
      return;
    }
    setSubmitting(true);
    setError(null);
    const apiData = {
      name: data.name,
      email: data.email,
      phone: data.phoneNumber,
      role: data.role,
      password: data.password,
      isVerified: true,
      File: files,
    };
    if (isSuperAdmin && twoFactorEnabled) {
      apiData.twoFactorEnabled = true;
      apiData.phone = data.twoFaPhone;
      apiData.countryCode = data.countryCode;
    }
    data.actionUrl = "adminuser";
    data.actionMethod = "post";
    data.apiData = apiData;
    dispatch(Entry(data)).then((resp) => {
      setSubmitting(false);
      if (resp.payload.code === 200) {
        //   navigate(-1);
        toast.success("User creation successful");
        handleClose();
        setIsUpdated(true);
      } else if (resp.payload.code === 401 || resp.payload.code === 400) {
        toast.error(resp.payload.message);
      } else {
        toast.error("Something went wrong!");
      }
    });
  }

  return (
    <div className={styles.popupbox}>
      <div className={styles.box} id={styles.box}>
        <button
          className={styles.closeicon}
          aria-label="Close"
          onClick={handleClose}
        >
          <FontAwesomeIcon icon={faTimes} />
        </button>
        <h2 className={styles.heading}>Create User</h2>
        <div className="container-fluid mt-5">
          <form onSubmit={handleSubmit(onSubmitdata)}>
            <div className="row">
              <div className="col-lg-6 col-md-12 col-sm-12">
                <TextInput
                  className={styles.inputbox}
                  classNamedark={styles.inputbox1}
                  labelstyle={styles.formlabel}
                  label="Name"
                  fieldName="name"
                  placeHolder="Enter Name"
                  register={register}
                  errors={errors}
                  isRequired
                  mandatory
                />
              </div>
              <div className="col-lg-6 col-md-12 col-sm-12">
                <EmailInput
                  className={styles.inputbox}
                  classNamedark={styles.inputbox1}
                  labelstyle={styles.formlabel}
                  label="Email"
                  placeHolder="Enter Email Address"
                  fieldName="email"
                  register={register}
                  errors={errors}
                  isRequired
                  mandatory
                />
              </div>
            </div>
            <div className="row">
              <div className="col-lg-6 col-md-12 col-sm-12">
                <PasswordField
                  fieldName="password"
                  className={styles.inputbox}
                  classNamedark={styles.inputbox1}
                  labelstyle={styles.formlabel}
                  label="Password"
                  register={register}
                  errors={errors}
                  placeHolder="Enter Password"
                  isRequired
                  minimLength={8}
                  eyeiconstyle={styles.eyeicon}
                  mandatory
                />
                {perror && <p className={styles[errormsgStyle]}>{perror}</p>}
              </div>
              <div className="col-lg-6 col-md-12 col-sm-12">
                <SelectBox
                  className={styles.inputbox}
                  classNamedark={styles.inputbox1}
                  name="role"
                  label="Role"
                  labelstyle={styles.formlabel}
                  control={control}
                  register={register}
                  values={roles}
                  errors={errors}
                  placeholder="Choose Role"
                  mandatory
                />
              </div>
            </div>

            {isSuperAdmin && (
              <>
                <div className="row mt-3">
                  <div className="col-lg-6 col-md-12 col-sm-12">
                    <div className="form-group">
                      <label className={styles.formlabel}>
                        Two-Factor Authentication
                      </label>
                      <div className="form-check mt-1">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          id="twoFactorToggle"
                          checked={twoFactorEnabled}
                          onChange={(e) => setTwoFactorEnabled(e.target.checked)}
                          aria-label="Enable Two-Factor Authentication"
                          tabIndex={0}
                        />
                        <label
                          className="form-check-label"
                          htmlFor="twoFactorToggle"
                        >
                          {twoFactorEnabled ? "Enabled" : "Disabled"}
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
                {twoFactorEnabled && (
                  <div className="row mt-2">
                    <div className="col-lg-6 col-md-12 col-sm-12">
                      <SelectBox
                        className={styles.inputbox}
                        classNamedark={styles.inputbox1}
                        name="countryCode"
                        label="Country Code"
                        labelstyle={styles.formlabel}
                        control={control}
                        register={register}
                        values={COUNTRY_CODES}
                        errors={errors}
                        placeholder="Select country code"
                        mandatory
                      />
                    </div>
                    <div className="col-lg-6 col-md-12 col-sm-12">
                      <PhoneNumberInput
                        className={styles.inputbox}
                        classNamedark={styles.inputbox1}
                        labelstyle={styles.formlabel}
                        label="2FA Phone Number"
                        fieldName="twoFaPhone"
                        register={register}
                        errors={errors}
                        isRequired
                        mandatory
                      />
                    </div>
                  </div>
                )}
              </>
            )}

            <div className="row mt-3">
              <div className="col-lg-6 col-md-12 col-sm-12">
                <MultipleFileUpload register={register} errors={errors} />
              </div>
            </div>
            <div className="d-flex">
              <input
                className={styles.formbtn}
                type="submit"
                disabled={submiting}
                value={submiting ? "Please wait.." : "Submit"}
              />
              {/* <input
                  className={styles.resetbtn}
                  type="button"
                  value="Reset"
                  onClick={() => {
                    reset();
                  }}
                /> */}
            </div>
            <br />
          </form>
        </div>
      </div>
    </div>
  );
});

export default CreateVendorPopup;
